import { render, staticRenderFns } from "./LocalePriorityItem.vue?vue&type=template&id=ece3b85a&scoped=true"
import script from "./LocalePriorityItem.vue?vue&type=script&lang=js"
export * from "./LocalePriorityItem.vue?vue&type=script&lang=js"
import style0 from "./LocalePriorityItem.vue?vue&type=style&index=0&id=ece3b85a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece3b85a",
  null
  
)

export default component.exports